import * as React from "react";
import { useEffect } from "react";
import { useNavigate, NavigateFunction } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { triggerOktaLogin } from "../../utils/oktaUtil";
import { navigateTo } from "../../../navigateTo";
import {IRIS_ORIGINAL_URI_KEY} from "../root/SecureRoute";

export const LandingPage: React.FunctionComponent = () => {
    const { authState } = useOktaAuth();
    const navigate: NavigateFunction = useNavigate();

    useEffect(() => {
        if (authState?.isAuthenticated) {
            navigateTo("/home", navigate);
        }
    }, [authState?.isAuthenticated, navigate]);

    const handleSignIn = () => {
        const storedUri = localStorage.getItem(IRIS_ORIGINAL_URI_KEY);

        let originalUri = storedUri || "/home";
        if (originalUri === "/landing" || originalUri === "/" || originalUri === "/login/callback") {
            originalUri = "/home";
        }

        triggerOktaLogin(originalUri).catch((err) =>
            console.error("Sign-in error:", err)
        );
    };

    const renderAonLogo = () => (
        <div role="img" aria-label="Aon" className="landing-page__aon-logo" />
    );

    if (authState?.isAuthenticated) {
        return null;
    }

    return (
        <div className="landing-page">
            <div className="landing-page__left-panel">
                <div className="landing-page__logo-header">
                    <span className="landing-page__logo-text">AON</span>
                    <span className="landing-page__logo-divider">|</span>
                    <span className="landing-page__logo-iris">Iris</span>
                </div>
            </div>

            <div className="landing-page__right-panel">
                <div className="landing-page__sign-in-card">
                    <h1 className="landing-page__welcome-title">Welcome Back</h1>
                    <p className="landing-page__welcome-subtitle">Sign in to access your investment insights</p>

                    <div className="landing-page__sign-in-box">
                        {renderAonLogo()}
                        <h2 className="landing-page__sign-in-title">Sign In</h2>
                        <p className="landing-page__sign-in-description">
                            Click below to securely sign in with your Aon credentials
                        </p>

                        <button 
                            className="landing-page__sign-in-button"
                            onClick={handleSignIn}
                            data-testid="landing-sign-in-button"
                        >
                            <i className="fa-solid fa-arrow-right-to-bracket" aria-hidden="true" />
                            Continue to Sign In
                        </button>

                        <div className="landing-page__support-link">
                            Need help?{" "}
                            {/* eslint-disable-next-line react/forbid-dom-props */}
                            <a href="mailto:support@aoniris.com">Contact Support</a>
                        </div>
                    </div>

                    <div className="landing-page__secure-notice">
                        <h3 className="landing-page__secure-notice-title">Secure Authentication</h3>
                        <p className="landing-page__secure-notice-text">
                            You'll be redirected to Aon's secure login page to enter your credentials,
                            then returned to Iris.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};